import { createFileRoute } from '@tanstack/react-router'
import { PengantarWilayahManager } from '../../../../components/pengantar-wilayah/PengantarWilayahManager'

export const Route = createFileRoute('/desa/$slug/dashboard/pengantar-wilayah')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <PengantarWilayahManager desaId={desaId} />
  },
})
